import { IDataConnectionType } from '../types/IDataConnection';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetDataConnectionTypesResult extends IGetItemsResult {
  dataConnectionTypes: IDataConnectionType[];
}

export class GetDataConnectionTypesRequest extends Request<IGetItemsParams, IGetDataConnectionTypesResult> {
  constructor(params: IGetItemsParams) {
    super('getDataConnectionTypes', params);
  }
}
